// gb-cart-ajax.js — (1) intercept add-to-cart form submits and open the drawer instead of /cart,
// (2) sync the free-shipping progress bar from /cart.js after every cart change.

(function () {
  'use strict';

  // Guard against the script being loaded more than once on a page —
  // a double-loaded IIFE would register the submit listener twice and
  // each "Add" click would fetch /cart/add.js two times.
  if (window.__gbCartAjaxLoaded) return;
  window.__gbCartAjaxLoaded = true;

  function findDrawer() {
    return document.querySelector('cart-drawer');
  }

  // ---------- Free-shipping progress bar sync ----------

  function getThresholdCents() {
    var dr = findDrawer();
    var raw = dr && dr.getAttribute('data-gb-threshold-cents');
    var n = parseInt(raw, 10);
    return isFinite(n) && n > 0 ? n : 6000;
  }

  function syncProgressBar() {
    var threshold = getThresholdCents();
    var tracks = document.querySelectorAll('.gb-cd-progress-track');
    if (!tracks.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pct = Math.min(100, Math.round((cart.total_price * 100) / threshold));
        tracks.forEach(function (el) {
          el.style.setProperty('--gb-pct', pct + '%');
          el.classList.toggle('is-reached', cart.total_price >= threshold);
        });
      })
      .catch(function () {});
  }

  function setupProgressObserver() {
    var dr = document.getElementById('CartDrawer');
    if (!dr || !('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(syncProgressBar, 60);
    }).observe(dr, { childList: true, subtree: true });
  }

  function initProgress() {
    syncProgressBar();
    setupProgressObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProgress);
  } else {
    initProgress();
  }

  // ---------- Add-to-cart intercept ----------

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      btn.disabled = true;
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      btn.disabled = false;
    }
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !busy);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;

      // <product-form> (Dawn) already does AJAX + drawer-open. Don't double-handle.
      if (form.closest('product-form')) return;

      // Quick-add buttons inside the drawer use their own click handler that
      // calls preventDefault on the click — but if they ever fall through to
      // submit, let the existing handler run instead of double-firing.
      if (form.querySelector('[data-gb-quick-add]')) return;

      e.preventDefault();

      var btn = form.querySelector('[type="submit"]') || form.querySelector('button');
      setBusy(btn, true);

      var drawer = findDrawer();
      var fd = new FormData(form);

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(document.activeElement);
        }
      } else {
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
      }

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript',
        },
        body: fd,
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && Number(res.status) >= 400) {
            console.error('[gb-cart-ajax] add failed:', res.message || res.description);
            return;
          }

          if (drawer) {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (typeof drawer.renderContents === 'function') {
              drawer.renderContents(res);
            } else if (typeof drawer.open === 'function') {
              drawer.open();
            }
            // Belt-and-suspenders: also sync the progress bar directly,
            // in case Liquid evaluated with stale cart state.
            setTimeout(syncProgressBar, 80);
          } else {
            // No drawer present — preserve original behavior.
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          console.error('[gb-cart-ajax] network error:', err);
        })
        .finally(function () {
          setBusy(btn, false);
        });
    },
    true /* capture phase, run before other listeners */
  );
})();
